import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import StatusBadge from '../statusBadge.component';

class StatusCellRenderer extends PureComponent {
  static propTypes = {
    value: PropTypes.string,
  };

  render() {
    const { value } = this.props;

    return (
      <StatusBadge className="table-badge" value={value} />
    );
  }
}

export default StatusCellRenderer;
